import React from "react";
import { BulkTicketOrMeetingsPurchaseHistoryArgsType } from "./type";
import PurchaseOrderStatus from "shared/enums/PurchaseOrderStatus";

export default function useBulkTicketOrMeetingsPurchaseHistoryService(
  props: BulkTicketOrMeetingsPurchaseHistoryArgsType
) {
  const completedPurchaseHistoryList = React.useMemo(
    () =>
      props.purchaseHistory?.filter(po => {
        if (po.purchaseOrderStatus !== PurchaseOrderStatus.COMPLETED) {
          return false;
        }
        if (props.originatingEntityId) {
          return po.lines.some(line => line.originatingEntityId === props.originatingEntityId);
        }
        return true;
      }),
    [props.purchaseHistory, props.originatingEntityId]
  );

  return { completedPurchaseHistoryList };
}
